import _ from "lodash"
import ImageComponent from "../Layouts/ImageComponent"
import moment from "moment"
import { useState } from "react"
import RenewalTableModel from "../modal/RenewalTableModal"
import { useNavigate } from "react-router-dom"
import ConfirmModal from "../modal/ConfirmModal"

const MySubscriptionServiceCard = ({
    subscription, key, submitCancelRequest, isPast
}) => {

    const navigate = useNavigate();
    const [renewalModal, setRenewalModal] = useState(false)
    const [confirmModal, setConfirmModal] = useState(false)
    const [modalMsg, setModalMsg] = useState('')

    return (
        <>
            {
                !_.isEmpty(subscription) ?
                    <>
                        <div className="cart-description-ex">
                            <div className="image-cart position-relative">
                                <ImageComponent
                                    name={subscription.name}
                                    thumbnail={subscription.thumbnail}
                                    cssClass={''}
                                    errorClass={'h-100'}
                                    handleClick={() => { }}
                                />
                                <span className="combo-tag text-capitalize">{subscription.label}</span>
                            </div>
                            <div className="desc-content">
                                <div className="wrapper-desc">
                                    <p
                                        className=""
                                        dangerouslySetInnerHTML={{
                                            __html: subscription.name,
                                        }}
                                        onClick={() => { }}
                                    ></p>
                                    {/* <div className="desc-wrap content-cart">
                                        <h2>
                                            ${subscription?.total_amount?.split(".")[0]}
                                            <sup>
                                                {subscription?.total_amount?.split(".")[1]
                                                    ? subscription?.total_amount?.split(".")[1]
                                                    : ""}
                                            </sup>
                                            &nbsp;CAD
                                            {
                                                subscription.payment_frequency ?
                                                    <span>/{subscription.payment_frequency.toLowerCase()}</span>
                                                    : ""
                                            }
                                        </h2>
                                    </div> */}
                                </div>
                                <div className="order-content">
                                    {!isPast ? 
                                    <div className="order-text">
                                        <p>
                                            Subscription Started on{" "}
                                            <span>
                                                {subscription.sub_start_date ? moment.unix(subscription.sub_start_date).format("Do MMM YYYY") : ""}
                                            </span>{" "}
                                        </p>
                                        {subscription.is_active == '1' &&
                                        <p>
                                            Next Renewal date {" "}
                                            <span>
                                                {subscription.next_renewal_date ? moment.unix(subscription.next_renewal_date).format("Do MMM YYYY") : ""}
                                            </span>{" "}
                                        </p>}
                                    </div> :
                                    <div className="order-text">
                                        <p>
                                            Subscription Started on{" "}
                                            <span>
                                                {subscription.sub_start_date ? moment.unix(subscription.sub_start_date).format("Do MMM YYYY") : ""}
                                            </span>{" "}
                                        </p>
                                        {subscription.is_active == '0' &&
                                        <p>
                                            Subscription Ended on{" "}
                                            <span>
                                                {_.toNumber(subscription.is_cancelled) ? subscription.cancel_date ? moment.unix(subscription.cancel_date).format("Do MMM YYYY") : "" : 
                                                subscription.updated_at ? moment.unix(subscription.updated_at).format("Do MMM YYYY") : ""}
                                            </span>{" "}
                                        </p>}
                                    </div>
                                    }
                                    <div className="order-cart">
                                        {
                                            !_.isEmpty(subscription.renewal_data) ?
                                                <>
                                                    <button
                                                        className="btn-order btn-primary"
                                                        onClick={() => {
                                                            setRenewalModal(true)
                                                        }}
                                                    >
                                                        View Renewal Details
                                                    </button>
                                                    {/* {
                                    (subscription.is_paid && !_.toNumber(subscription.is_cancelled)) ?
                                    <button class="btn-cancel-sub"
                                    onClick={() => 
                                        submitCancelRequest(
                                            subscription.order_id, 
                                            subscription.stripe_subscription_id
                                        )
                                    }>
                                        Cancel Subscription</button>
                                    : ""
                                } */}
                                                </>
                                                : ""
                                        }
                                        {
                                            (subscription.is_active == '0' && subscription.available_for_purchase) &&
                                            <button
                                                className="btn-order btn-primary"
                                                onClick={() => {
                                                    navigate(`/shopping/${subscription.post_id}?source=services&addToCart=false`)
                                                }}
                                            >
                                                Buy Now
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <RenewalTableModel
                            subscription={subscription}
                            renewalModal={renewalModal}
                            setRenewalModal={setRenewalModal}
                            setConfirmModal={setConfirmModal}
                            setModalMsg={setModalMsg}
                        />
                        <ConfirmModal 
                            confirmModal={confirmModal}
                            setConfirmModal={setConfirmModal}
                            showModalMsg={modalMsg}
                            isConfirm={false}
                            confirmId={''}
                            confirmAction={() => {}}
                            isRightIcon={false}
                        />
                    </>
                    : ""
            }
        </>
    )
}

export default MySubscriptionServiceCard